let _pendingFile = null;

export const setPendingFile = (file) => { _pendingFile = file; };
export const getPendingFile = () => { const f = _pendingFile; _pendingFile = null; return f; };
